import React, { useEffect, useState } from "react";
import { useTranslation } from "../contexts/LocaleContext";
import SelectOption from "./SelectOption";

const AddEmailModal = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  initialData,
}) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    id: "",
    mailUser: "",
    mailPassword: "",
    mailKey: "",
    smtpServeraddress: "",
    port: "",
    ip: "",
    status: "1",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (isOpen) {
      if (initialData) {
        setForm({
          id: initialData.id ?? initialData._id ?? "",
          mailUser: initialData.mailUser ?? "",
          mailPassword: initialData.mailPassword ?? "",
          mailKey: initialData.mailKey ?? "",
          smtpServeraddress:
            initialData.smtpServeraddress ??
            initialData.smtpServerAddress ??
            "",
          port: initialData.port ?? "",
          ip: initialData.ip ?? "",
          status: initialData.status ?? "1",
        });
        setErrors({});
      } else {
        setForm({
          id: "",
          mailUser: "",
          mailPassword: "",
          mailKey: "",
          smtpServeraddress: "",
          port: "",
          ip: "",
          status: "1",
        });
        setErrors({});
      }
    }
  }, [isOpen, initialData]);

  if (!isOpen) return null;

  const handleChange = (field, value) => {
    setForm((p) => ({ ...p, [field]: value }));
    // clear field error on change
    setErrors((e) => {
      const next = { ...e };
      delete next[field];
      return next;
    });
  };

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    // client-side validation
    const newErrors = {};
    if (!String(form.mailUser).trim())
      newErrors.mailUser = t
        ? t("email.modal.mail_user_required") || "Mail User is required"
        : "Mail User is required";
    if (!String(form.mailPassword).trim())
      newErrors.mailPassword = t
        ? t("email.modal.mail_password_required") || "Mail Password is required"
        : "Mail Password is required";
    if (!String(form.smtpServeraddress).trim())
      newErrors.smtpServeraddress = t
        ? t("email.modal.smtp_required") || "SMTP Server is required"
        : "SMTP Server is required";
    if (!String(form.port).trim())
      newErrors.port = t
        ? t("email.modal.port_required") || "Port is required"
        : "Port is required";
    else if (!/^\d+$/.test(String(form.port).trim()))
      newErrors.port = t
        ? t("email.modal.port_number") || "Port must be a number"
        : "Port must be a number";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    if (onSubmit) {
      await onSubmit(form);
    }
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal-card">
        <div className="modal-header">
          <h3>
            {form.id
              ? t
                ? t("email.modal.edit")
                : "Edit Email"
              : t
              ? t("email.modal.add")
              : "Add Email"}
          </h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <form className="modal-body" onSubmit={handleSubmit}>
          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767774141302"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="26888"
                  width="200"
                  height="200"
                >
                  <path
                    d="M469.333333 661.333333c0-24.021333 7.936-46.165333 21.333334-64H224.085333a95.957333 95.957333 0 0 0-95.957333 96v24.618667c0 38.058667 13.610667 74.922667 38.357333 103.893333 66.816 78.250667 168.618667 116.906667 302.848 116.906667h2.133334A107.264 107.264 0 0 1 469.333333 917.333333v-42.624c-116.821333 0-200.704-31.786667-254.208-94.421333a96 96 0 0 1-22.997333-62.336v-24.661333c0-17.621333 14.336-31.957333 32-31.957334H469.333333zM469.333333 85.546667a213.333333 213.333333 0 1 1 0 426.666666 213.333333 213.333333 0 0 1 0-426.666666z m0 64a149.333333 149.333333 0 1 0 0 298.666666 149.333333 149.333333 0 0 0 0-298.666666zM747.093333 807.552l-234.282666-136.661333A85.333333 85.333333 0 0 1 597.333333 597.333333h298.666667a85.333333 85.333333 0 0 1 85.333333 84.053334l-234.24 126.165333z"
                    p-id="26889"
                  ></path>
                  <path
                    d="M756.778667 850.773333L981.333333 729.941333V896a85.333333 85.333333 0 0 1-85.333333 85.333333h-298.666667a85.333333 85.333333 0 0 1-85.333333-85.333333v-176.213333l223.914667 130.645333a21.333333 21.333333 0 0 0 20.864 0.384z"
                    p-id="26890"
                  ></path>
                </svg>
              </span>
              {t ? t("emails.table.mail_user") : "Mail User"}
            </label>
            <input
              value={form.mailUser}
              onChange={(e) => handleChange("mailUser", e.target.value)}
            />
            {errors.mailUser && (
              <div className="form-error">{errors.mailUser}</div>
            )}
          </div>

          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767855239372"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="37218"
                  width="200"
                  height="200"
                >
                  <path
                    d="M418.133333 499.2c-21.333333-34.133333-29.866667-72.533333-29.866666-115.2 0-119.466667 93.866667-213.333333 213.333333-213.333333s213.333333 93.866667 213.333333 213.333333-93.866667 213.333333-213.333333 213.333333c-46.933333 0-85.333333-12.8-123.733333-38.4l-98.133334 98.133334 46.933334 46.933333-59.733334 59.733333-46.933333-46.933333-29.866667 29.866667 46.933334 46.933333L277.333333 853.333333 170.666667 746.666667l247.466666-247.466667zM601.6 256c-72.533333 0-128 55.466667-128 128s55.466667 128 128 128 128-55.466667 128-128-59.733333-128-128-128z"
                    fill="#000000"
                    p-id="37219"
                  ></path>
                </svg>
              </span>
              {t ? t("emails.table.mail_password") : "Mail Password"}
            </label>
            <input
              value={form.mailPassword}
              onChange={(e) => handleChange("mailPassword", e.target.value)}
            />
            {errors.mailPassword && (
              <div className="form-error">{errors.mailPassword}</div>
            )}
          </div>

          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767855535698"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="42640"
                  width="200"
                  height="200"
                >
                  <path
                    d="M874.666667 426.666667h-725.333334a64 64 0 0 0-64 64v469.333333a64 64 0 0 0 64 64h725.333334a64 64 0 0 0 64-64v-469.333333a64 64 0 0 0-64-64z m-21.333334 85.333333v426.666667h-682.666666v-426.666667h682.666666z"
                    fill="#000000"
                    p-id="42641"
                  ></path>
                  <path
                    d="M512 0a256 256 0 0 0-256 256v256h512v-256a256 256 0 0 0-256-256z m8.533333 85.546667A170.666667 170.666667 0 0 1 682.666667 256v170.666667h-341.333334v-170.666667a170.666667 170.666667 0 0 1 170.666667-170.666667l8.533333 0.213334z"
                    fill="#000000"
                    p-id="42642"
                  ></path>
                  <path
                    d="M469.333333 597.333333m42.666667 0l0 0q42.666667 0 42.666667 42.666667l0 170.666667q0 42.666667-42.666667 42.666666l0 0q-42.666667 0-42.666667-42.666666l0-170.666667q0-42.666667 42.666667-42.666667Z"
                    fill="#000000"
                    p-id="42643"
                  ></path>
                </svg>
              </span>
              {t ? t("emails.table.mail_key") : "Mail Key"}
            </label>
            <input
              value={form.mailKey}
              onChange={(e) => handleChange("mailKey", e.target.value)}
            />
          </div>

          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M12 2a10 10 0 100 20 10 10 0 000-20zM12 6a6 6 0 110 12 6 6 0 010-12z"
                    fill="#000000"
                  />
                </svg>
              </span>
              {t ? t("emails.table.ip") : "IP"}
            </label>
            <input value={form.ip} onChange={(e) => handleChange("ip", e.target.value)} />
          </div>

          <div className="form-row ">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767855578631"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="44740"
                  width="200"
                  height="200"
                >
                  <path
                    d="M992 624a16 16 0 0 1 15.744 13.12l0.256 2.88v128a16 16 0 0 1-13.12 15.744L992 784l2.88 0.256a16 16 0 0 1 12.864 12.864l0.256 2.88v128a16 16 0 0 1-13.12 15.744L992 944h-288a16 16 0 0 1-15.744-13.12L688 928v-128a16 16 0 0 1 13.12-15.744L704 784l-2.88-0.256a16 16 0 0 1-12.864-12.864L688 768v-128a16 16 0 0 1 13.12-15.744L704 624h288z m-16 192h-256v96h256v-96zM896 832a32 32 0 1 1 0 64 32 32 0 0 1 0-64z m80-176.032h-256V752h256v-96.032zM896 672a32 32 0 1 1 0 64 32 32 0 0 1 0-64z"
                    fill="#000000"
                    p-id="44741"
                  ></path>
                  <path
                    d="M784 144v214.304l96 82.336V576h-32v-97.568L706.496 576h-56.32l101.824-70.208V176h-480v330.464l176.672 123.04h123.968L640 583.008v38.848l-35.168 24.288 35.168 26.784v40.288l-67.808-51.712h-123.072l-242.048 186.432L640 847.904v32.064L144 880V440.64l96-82.144V144h544z m-608 334.624v352.8l240.608-185.28L176 478.624z m64-78.016l-53.888 46.08L240 484.192v-83.584z m544-0.16v83.264l53.824-37.12-53.824-46.144zM704 432v32H320v-32h384z m0-96v32H320v-32h384z m-288-96v32h-96v-32h96z"
                    fill="#000000"
                    p-id="44742"
                  ></path>
                </svg>
              </span>
              {t ? t("emails.table.smtp_server") : "SMTP Server"}
            </label>
            <input
              value={form.smtpServeraddress}
              onChange={(e) =>
                handleChange("smtpServeraddress", e.target.value)
              }
            />
            {errors.smtpServeraddress && (
              <div className="form-error">{errors.smtpServeraddress}</div>
            )}
          </div>

          <div className="form-row ">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767855629042"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="46703"
                  width="200"
                  height="200"
                >
                  <path
                    d="M246.0672 716.0832c-16.896 0-32.5632 7.0656-43.7248 18.3296-11.264 11.4688-18.1248 27.3408-18.1248 44.032 0 17.1008 6.8608 32.5632 18.1248 43.7248 11.264 11.264 26.9312 18.1248 43.7248 18.1248 16.896 0 32.4608-6.8608 43.7248-18.1248 11.264-11.264 18.5344-26.624 18.5344-43.7248 0-16.5888-7.3728-32.5632-18.5344-44.032-11.1616-11.264-26.8288-18.3296-43.7248-18.3296z m14.9504 76.6976v0.2048c-3.8912 3.8912-9.3184 6.144-14.848 6.144-5.8368 0-11.0592-2.2528-14.9504-6.144v-0.2048c-3.6864-3.1744-5.8368-8.6016-5.8368-14.4384 0-5.4272 2.1504-11.264 5.8368-14.9504 3.8912-4.1984 9.0112-5.8368 14.9504-5.8368 5.632 0 10.9568 1.7408 14.848 5.8368 3.3792 3.6864 5.8368 9.5232 5.8368 14.9504 0 5.9392-2.4576 11.264-5.8368 14.4384zM246.0672 450.2528c-16.896 0-32.5632 6.5536-43.7248 18.1248-11.264 11.264-18.1248 26.4192-18.1248 43.7248 0 17.1008 6.8608 32.5632 18.1248 43.7248v0.512c11.264 11.264 26.9312 17.8176 43.7248 17.8176 16.896 0 32.4608-6.656 43.7248-17.8176v-0.512c11.264-11.264 18.5344-26.624 18.5344-43.7248 0-17.3056-7.3728-32.5632-18.5344-43.7248-11.1616-11.5712-26.8288-18.1248-43.7248-18.1248z m14.9504 76.8c-3.8912 3.4816-9.3184 5.8368-14.848 5.8368-5.8368 0-11.0592-2.4576-14.9504-5.8368-3.6864-4.1984-5.8368-9.0112-5.8368-14.9504 0-5.8368 2.1504-10.9568 5.8368-14.4384 3.8912-4.1984 9.0112-6.3488 14.9504-6.3488 5.632 0 10.9568 2.2528 14.848 6.3488 3.3792 3.3792 5.8368 8.6016 5.8368 14.4384 0 5.9392-2.4576 10.752-5.8368 14.9504zM246.0672 183.7056c-16.896 0-32.5632 7.3728-43.7248 18.1248-11.264 11.264-18.1248 27.136-18.1248 44.2368 0 16.896 6.8608 32.0512 18.1248 43.3152v0.512c11.264 11.0592 26.9312 18.1248 43.7248 18.1248 16.896 0 32.4608-7.0656 43.7248-18.1248v-0.512c11.264-11.264 18.5344-26.4192 18.5344-43.3152 0-17.1008-7.3728-32.9728-18.5344-44.2368-11.1616-10.752-26.8288-18.1248-43.7248-18.1248z m14.9504 76.8c-3.8912 3.8912-9.3184 5.8368-14.848 5.8368-5.8368 0-11.0592-1.9456-14.9504-5.8368-3.6864-3.3792-5.8368-8.8064-5.8368-14.4384 0-5.8368 2.1504-11.264 5.8368-14.848v-0.512c3.8912-2.9696 9.0112-5.8368 14.9504-5.8368 5.632 0 10.9568 2.9696 14.848 5.8368v0.512c3.3792 3.6864 5.8368 9.0112 5.8368 14.848 0 5.632-2.4576 11.0592-5.8368 14.4384z"
                    p-id="46704"
                    fill="#000000"
                  ></path>
                  <path
                    d="M966.656 185.6512c0-29.7984-12.0832-59.1872-33.28-80.5888l-2.048-2.048h-0.512c-21.2992-20.48-48.9472-31.8464-78.1312-31.8464H171.52c-30.0032 0-59.392 12.288-80.5888 33.792C69.632 126.1568 57.344 155.5456 57.344 185.6512V306.176c0 26.5216 9.216 52.224 26.112 73.0112C66.56 399.4624 57.344 424.8576 57.344 451.4816v121.0368c0 26.9312 9.216 52.4288 26.112 72.704C66.56 665.6 57.344 691.0976 57.344 717.7216v121.0368c0 29.2864 11.4688 57.6512 31.5392 78.4384v0.3072l2.048 2.048c21.4016 21.0944 50.7904 33.28 80.5888 33.28h681.1648c29.4912 0 57.6512-11.5712 79.36-32.4608l0.512-0.3072 0.8192-0.8192c21.1968-21.1968 33.28-50.4832 33.28-80.384V717.7216c0-26.624-9.4208-52.1216-26.5216-72.6016 16.896-20.0704 26.5216-46.1824 26.5216-72.704V451.4816c0-26.5216-9.4208-51.9168-26.624-72.192 17.2032-20.8896 26.624-46.592 26.624-73.0112V185.6512z m-82.6368 653.1072c0 10.24-5.12 17.92-9.4208 22.4256l-0.4096 0.4096c-5.4272 5.3248-12.9024 8.192-21.504 8.192H171.52c-8.4992 0-16.1792-2.8672-21.8112-7.9872l-0.4096-0.8192-0.7168-0.8192c-3.8912-4.096-8.6016-11.1616-8.6016-21.4016V717.7216c0-8.2944 3.2768-16.384 9.0112-22.016l0.4096-0.4096c6.0416-5.5296 13.4144-8.6016 21.2992-8.8064h683.008c7.68 0.2048 15.2576 3.4816 21.2992 9.3184l0.4096 0.4096c5.632 5.632 8.704 13.312 8.704 21.504v121.0368z m0-266.24c0 8.192-3.4816 16.4864-9.216 22.3232l-0.4096 0.512c-5.632 5.2224-13.2096 8.3968-20.7872 8.8064H170.7008c-8.2944-0.4096-15.9744-3.7888-21.8112-9.3184l-0.3072-0.3072c-5.4272-5.9392-8.6016-13.9264-8.6016-21.9136V451.4816c0-7.7824 2.9696-15.36 8.2944-21.504l0.2048-0.1024 0.8192-0.7168c5.632-5.2224 12.9024-8.2944 21.6064-9.216h682.496c8.9088 0.9216 16.2816 4.096 21.4016 9.216l0.4096 0.4096c5.8368 6.3488 8.8064 13.7216 8.8064 21.9136v121.0368z m0-266.24c0 8.3968-3.2768 16.384-9.216 22.3232l-0.4096 0.4096c-5.8368 5.632-13.4144 8.8064-20.6848 8.8064H170.496c-7.68 0-15.36-3.2768-21.6064-9.216l-0.3072-0.3072c-5.5296-5.9392-8.704-13.9264-8.704-22.016V185.6512c0-8.4992 3.1744-16.4864 8.9088-22.2208l0.512-0.4096c5.9392-5.8368 13.6192-8.8064 22.1184-8.8064h681.1648c8.6016 0 16.1792 3.1744 22.016 9.1136l0.6144 0.6144c5.7344 5.7344 8.8064 13.312 8.8064 21.8112v120.5248z"
                    p-id="46705"
                    fill="#000000"
                  ></path>
                </svg>
              </span>
              {t ? t("emails.table.port") : "Port"}
            </label>
            <input
              value={form.port}
              onChange={(e) => handleChange("port", e.target.value)}
            />
            {errors.port && <div className="form-error">{errors.port}</div>}
          </div>

          <div className="form-row">
            <label>
              <span className="label-icon" aria-hidden="true">
                <svg
                  t="1767855715723"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="51363"
                  width="200"
                  height="200"
                >
                  <path
                    d="M556.195 809.433c16.058-2.857 31.109-5.643 45.606-10.422 84.613-27.895 144.845-83.138 182.884-163.31 3.17-6.679 1.161-8.446-5.17-10.18-17.52-4.798-34.898-10.146-52.248-15.544-16.339-5.084-20.286-20.612-7.877-32.418A54797.681 54797.681 0 0 1 897.36 408.986c12.211-11.513 28.276-6.47 32.07 9.968 18.325 79.42 36.537 158.866 54.536 238.362 4.002 17.673-7.473 27.63-24.941 22.316-16.45-5.007-33.075-9.544-49.224-15.39-7.845-2.841-10.34-0.622-13.341 6.377-43.504 101.517-115.47 175.43-215.952 221.438-12.984 5.946-26.299 11.085-39.945 15.335-2.253 0.701-4.133 2.72-6.441-0.922-19.061-30.076-44.465-55.113-66.362-82.951-3.583-4.557-7.354-8.967-11.566-14.086zM802.005 445.003c-6.135-23.324-13.71-44.906-24.475-65.279-37.11-70.244-93.668-117.666-168.27-144.21-7.006-2.493-9.786-1.47-11.82 5.99-4.946 18.147-10.748 36.06-16.408 54.005-5.688 18.02-22.268 21.913-35.025 8.002-54.324-59.253-108.543-118.6-162.703-178.005-12.807-14.046-7.824-29.073 10.788-33.13 77.415-16.868 154.84-33.691 232.263-50.516a93.03 93.03 0 0 1 6.717-1.218c13.445-1.913 23.455 9.359 19.483 22.385-5.109 16.755-10.385 33.47-16.22 49.98-2.324 6.583-1.68 8.967 5.626 11.474 116.98 40.143 200.529 116.948 251.136 229.82 3.554 7.925 3.022 11.555-5.501 14.567-7.319 2.587-13.436 7.77-19.124 13.224-19.5 18.698-39.07 37.323-58.636 55.953-2.26 2.155-4.666 4.156-7.83 6.958zM430.321 232.818c-31.57 10.377-60.088 24.128-86.05 42.92-45.292 32.784-79.09 74.732-101.307 126.111-2.765 6.397-1.518 7.893 4.946 9.213 16.527 3.375 32.889 7.566 49.296 11.524 16.287 3.926 21.463 19.81 9.955 32.004C251.105 514 194.906 573.276 138.606 632.456c-11.96 12.572-28.126 8.372-32.835-8.506-22.056-79.06-43.946-158.169-65.783-237.29-3.753-13.606 7.024-25.029 20.765-21.956 19.321 4.32 38.626 8.774 57.753 13.867 6.795 1.81 9.419 0.276 11.899-6.254 39.176-103.163 108.881-178.564 207.491-227.683 6.3-3.14 9.537-2.36 14.27 2.91 25.406 28.316 51.356 56.147 78.155 85.274zM227.253 586.871c23.597 88.533 76.274 152.741 156.751 194.73 7.277 3.795 9.62 1.932 12.083-5.07 5.484-15.592 11.626-30.962 17.786-46.308 6.29-15.682 21.268-18.283 31.9-5.453 51.691 62.372 103.33 124.793 154.846 187.31 12.733 15.45 7.023 28.972-13.035 32.217-78.918 12.764-157.824 25.609-236.735 38.409-2.246 0.364-4.52 0.61-6.787 0.781-15.587 1.173-24.756-10.425-19.3-25.126a1556.39 1556.39 0 0 1 22.102-56.115c2.394-5.754 1.475-7.958-4.292-10.658-95.606-44.726-163.829-116.25-207.185-212.137-3.041-6.723-2.543-9.148 4.89-10.705 8.188-1.712 14.307-7.403 19.985-13.34 19.792-20.701 39.56-41.433 59.408-62.083 2.185-2.272 3.788-5.318 7.583-6.452z"
                    p-id="51364"
                    fill="#000000"
                  ></path>
                </svg>{" "}
              </span>
              {t ? t("emails.table.status") : "Status"}
            </label>
            <SelectOption
              value={form.status}
              onChange={(v) => handleChange("status", v)}
              options={[
                { value: "1", label: t ? t("status.on") : "ON" },
                { value: "0", label: t ? t("status.off") : "OFF" },
              ]}
              ariaLabel="邮件状态"
            />
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-ghost" onClick={onClose}>
              {t ? t("user.modal.cancel") : "Cancel"}
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={
                isLoading ||
                Object.keys(errors).length > 0 ||
                !form.mailUser ||
                !form.mailPassword ||
                !form.smtpServeraddress ||
                !form.port
              }
            >
              {isLoading ? (
                <>
                  <span className="btn-spinner" aria-hidden="true" />
                  {t ? t("user.modal.save") : "Saving..."}
                </>
              ) : t ? (
                t("user.modal.save")
              ) : (
                "Save"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEmailModal;
